import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Honeybadger } from '@honeybadger-io/react';
import { useFormik } from 'formik';
import { useRecoilState } from 'recoil';

import { requestApi } from 'api/Api';

import { showAlert } from 'components/shared/Alert/Alert';

import adminState from '../../lib/adminState';

import Settings from './lib/AdminSettingsForm';
import { AdminSettingsValidationSchema } from './lib/AdminSettingsValidationSchema';

export default function AdminSettingsContainer() {
  const user = useRecoilState(adminState.current_admin);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [buttonCopy, setButtonCopy] = useState('Update');

  const formik = useFormik({
    initialValues: {
      f_name: user[0]?.f_name || '',
      l_name: user[0]?.l_name || '',
      email: user[0]?.email || ''
    },
    enableReinitialize: true,
    validationSchema: AdminSettingsValidationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      submitChanges(values);
      setSubmitting(false);
    }
  });

  const submitChanges = async (values) => {
    try {
      const onSuccess = () => {
        showAlert({ title: 'Admin updated successfully', color: 'primary' });
        setLoading(false);
        setButtonCopy('Saved');
      };
      const onError = (error) => {
        showAlert({ title: error, color: 'danger' });
        setLoading(false);
      };
      setLoading(true);
      await requestApi({
        url: '/api/admin/update',
        params: {
          admin: { ...values, id: user[0].user_id }
        },
        navigate,
        onSuccess,
        onError
      });
    } catch (err) {
      Honeybadger.notify(`There's been an unexpected error, please try again later. ${err}`);
    }
  };

  return (
    <Settings
      onSubmit={formik.submitForm}
      errors={formik.errors}
      formik={formik}
      buttonCopy={buttonCopy}
      loading={loading}
    />
  );
}
